<template>
    <div>

        <el-row>
            <div class="left-justifying"><h3>告警管理</h3></div>
            <div class="right-justifying">
                <el-button type="info" v-if="addShow" plain size="small" @click="addFunc"><i
                    class="fa fa-plus-circle"></i> 新建
                </el-button>
                <el-button type="info" v-if="updateShow" plain size="small" @click="updateFunc"><i
                    class="el-icon-edit"></i> 修改
                </el-button>
                <el-button type="info" v-if="saveShow" plain size="small" @click="saveFunc"><i
                    class="fa fa-save"></i> 保存
                </el-button>
                <el-button type="info" v-if="deleteShow" plain size="small" @click="btnDelClickHandle()">
                    <i class="fa fa-times"></i> 删除
                </el-button>
                <el-button type="info" v-if="sendWorkFlowShow" plain size="small" :disabled="sendWorkFlowButtonDisabled"
                           @click="sendWorkFlow"><i
                    class="el-icon-thumb"></i> 发送工作流
                </el-button>
                <el-button type="info" v-if="receivingOrdersShow" plain size="small" :disabled="receivingOrdersDisabled"
                           @click="receivingOrders"><i
                    class="el-icon-truck"></i> 接单
                </el-button>
                <el-button type="info" v-if="reexamineShow&&hasPermission('menu.newTicket.reexamine')" plain
                           size="small" :disabled="reexamineDisabled" @click="reexamine"><i
                    class="el-icon-copy-document"></i> 重新审核
                </el-button>
                <el-button type="info" v-if="eventReportShow&&hasPermission('menu.newTicket.makeEventReport')" plain
                           size="small" :disabled="eventReportDisabled" @click="makeEventReport"><i
                    class="el-icon-edit-outline"></i> 制作事件报告
                </el-button>
                <el-button type="info" v-if="exportExcelShow" plain size="small" :disabled="exportDisabled"
                           @click="exportExcelInfo"><i
                    class="el-icon-chat-line-square"></i> 导出
                </el-button>
                <el-button v-if="btnOpenBatchCancelVisible&&hasPermission('menu.newTicket.batchCancel')" type="info"
                           plain size="small"
                           @click="openBatchCancelDialogHandler">
                    <i class="el-icon-refresh-right"></i> 批量撤单
                </el-button>
                <el-button v-if="!btnOpenBatchCancelVisible && flagShow" type="info" plain size="small"
                           @click="confirmBatchCancelHandler">
                    <i class="el-icon-refresh-right"></i> 确认批量撤单
                </el-button>
                <el-button v-if="!btnOpenBatchCancelVisible && flagShow" type="info" plain size="small"
                           @click="cancelBatchCancelDialogHandler">
                    <i class="el-icon-refresh-right"></i> 取消
                </el-button>


                <el-button v-if="formCancel" type="info" plain size="small"
                           @click="formCancelFun">
                    <i class="el-icon-sort"></i> 取消<!--修改信息还原-->
                </el-button>
            </div>
        </el-row>

        <div class="panel">
            <div class="panel-body">
                <el-row>

                    <div v-show="paginationHidden" class="advanced-search-location">
                        <el-switch
                            v-model="searchParams.currentEvent"
                            active-color="#13ce66"
                            inactive-color="#CCC"
                        >
                        </el-switch>
                        当前事件
                        <el-tooltip style="margin-right: 4px;" effect="light" placement="top" popper-class="event-tip">
                            <i class="el-icon-question" style="color: #409eff"></i>
                            <template #content>
                                <div>打开当前事件按钮：查看今天和昨天未处理完工的告警</div>
                                <div>关闭当前事件按钮：查看所有告警</div>
                            </template>
                        </el-tooltip>
                        <AthubDropDownSearch ref="athubDropDownSearch" :model="searchParams"
                                             @formDataSubmit="queryTable" :formWidth="800" v-if="true" size="mini"
                                             collapseTags
                                             multiple>
                            <el-form :model="searchParams" label-width="80px">
                                <el-row type="flex" class="row-bg">
                                    <el-col :span="11">
                                        <el-form-item label="事件编号">
                                            <el-input size="small" style="width: 274px;"
                                                      v-model="searchParams.ticketid"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="11">
                                        <el-form-item label="数据中心">
                                            <SysroomSelectNew v-model="searchParams.dcnum"
                                             :filterDcIds="filterDcIds"
                                                              @fetchAllSysrooms="fetchAllSysrooms"
                                                              @sysroomClear="sysroomClear" clearable filterable
                                                              style="width: 274px;" size="mini"></SysroomSelectNew>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row type="flex" class="row-bg">
                                    <el-col :span="11">
                                        <el-form-item label="时间从">
                                            <el-date-picker v-model="searchParams.startTime" placeholder=">="
                                                            format="yyyy-MM-dd"
                                                            value-format="yyyy-MM-dd"/>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="11">
                                        <el-form-item label="到">
                                            <el-date-picker v-model="searchParams.endTime" placeholder="<="
                                                            format="yyyy-MM-dd"
                                                            value-format="yyyy-MM-dd"/>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row type="flex" class="row-bg">

                                    <el-col :span="11">
                                        <el-form-item label="事件来源">
                                            <dictionary-select v-model="searchParams.source" :factory-name="'domain'"
                                                               :params="'TICKETSOURCE'" filterable clearable
                                                               size="mini"></dictionary-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="11">
                                        <el-form-item label="事件类型">
                                            <el-select v-model="searchParams.tickettype" style="width: 274px;"
                                                       size="mini" @change="tickettypeChange()" placeholder="请选择"
                                                       clearable filterable>
                                                <el-option
                                                    v-for="item in tickettypes"
                                                    :key="item.failurecode"
                                                    :label="item.description"
                                                    :value="item.failurecode">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row type="flex" class="row-bg">
                                    <el-col :span="11">
                                        <el-form-item label="事件主题">
                                            <el-input size="mini" style="width: 274px;"
                                                      v-model="searchParams.description"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="11">
                                        <el-form-item label="事件等级">
                                            <dictionary-select v-model="searchParams.level" :factory-name="'domain'"
                                                               :params="'TICKETLEVEL'" filterable clearable
                                                               style="width: 274px;" size="mini"></dictionary-select>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row type="flex" class="row-bg">
                                    <el-col :span="11">
                                        <el-form-item label="故障类别">
                                            <el-select v-model="searchParams.failuretype" style="width: 274px;"
                                                       @change="failuretypeChange()" size="mini" placeholder="请选择"
                                                       clearable filterable>
                                                <el-option
                                                    v-for="item in failuretypes"
                                                    :key="item.failurecode"
                                                    :label="item.description"
                                                    :value="item.failurecode">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="11">
                                        <el-form-item label="故障现象">
                                            <el-select v-model="searchParams.failurecode" style="width: 274px;"
                                                       @change="failurecodeChange()" size="mini" placeholder="请选择"
                                                       clearable filterable>
                                                <el-option
                                                    v-for="item in failurecodes"
                                                    :key="item.failurecode"
                                                    :label="item.description"
                                                    :value="item.failurecode">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                </el-row>

                                <el-row type="flex" class="row-bg">
                                    <el-col :span="11">
                                        <el-form-item label="事件状态">
                                            <dictionary-select v-model="searchParams.status" @loaded="loaded"
                                                               :factory-name="'domain'" :params="'INCIDENTSTATUS'"
                                                               multiple filterable clearable style="width: 274px;"
                                                               size="mini"></dictionary-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="11">
                                        <el-form-item label="事件报告">
                                            <el-select v-model="searchParams.hasReport" size="mini"
                                                       style="width: 274px;" placeholder="请选择" clearable>
                                                <el-option
                                                    v-for="item in eventReports"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                </el-row>

                                <el-row type="flex" class="row-bg">
                                    <el-col :span="11">
                                        <el-form-item label="问题代码">
                                            <el-select v-model="searchParams.problemcode" style="width: 274px;"
                                                       size="mini" placeholder="请选择" clearable filterable>
                                                <el-option
                                                    v-for="item in problemcodes"
                                                    :key="item.failurecode"
                                                    :label="item.description"
                                                    :value="item.failurecode">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="11">
                                        <el-form-item label="设备">
                                            <el-input v-model="searchParams.assetnum" size="small"
                                                      class="width70" style="display: none;"></el-input>
                                            <el-input v-model="searchParamsNotSendBackstage.assetnumDescriptionNo"
                                                      size="mini"
                                                      class="width50" readOnly="true">
                                            </el-input>

                                            <el-button icon="el-icon-edit-outline" size="mini"
                                                       @click="openEquipment()"></el-button>
                                            <el-button icon="el-icon-delete" size="mini"
                                                       @click="deleteEquipment()"></el-button>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row type="flex" class="row-bg">
                                    <el-col :span="11">
                                        <el-form-item label="录入人员">
                                            <el-input size="mini" style="width: 274px;"
                                                      v-model="searchParams.enterby"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="11">
                                        <el-form-item label="位置">
                                            <el-input v-model="searchParams.location" size="small"
                                                      class="width70" style="display: none;"></el-input>
                                            <el-input v-model="searchParamsNotSendBackstage.locationDescriptionNo"
                                                      size="mini"
                                                      class="width50" readOnly="true">
                                            </el-input>

                                            <!--                                            <el-button  icon="el-icon-edit-outline" size="mini"
                                                                                                    @click="openLaction()"></el-button>-->
                                            <el-button icon="el-icon-edit-outline" size="mini"
                                                       :disabled="formDisable"
                                                       @click="openLaction()">
                                            </el-button>
                                            <el-button icon="el-icon-delete" size="mini"
                                                       @click="deleteLaction()">
                                            </el-button>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row type="flex" class="row-bg">
                                    <el-col :span="6">
                                        <el-form-item label="超时">
                                            <el-checkbox v-model="searchParams.acceptexpired" @change="setDate">
                                                <span>超时接单</span>
                                                <el-tooltip style="margin-right: 4px;" effect="light" placement="top" popper-class="event-tip">
                                                    <i class="el-icon-info"></i>
                                                    <template #content>
                                                        <div>接单时间超过5分钟。</div>
                                                    </template>
                                                </el-tooltip>
                                            </el-checkbox>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="6">
                                        <el-form-item label="">
                                            <el-checkbox v-model="searchParams.auditexpired" @change="setDate">
                                                <span>超时审批</span>
                                                <el-tooltip style="margin-right: 4px;" effect="light" placement="top" popper-class="event-tip">
                                                    <i class="el-icon-info"></i>
                                                    <template #content>
                                                        <div>超过7天未审批。</div>
                                                    </template>
                                                </el-tooltip>
                                            </el-checkbox>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="6">
                                        <el-form-item label="">
                                            <el-checkbox v-model="searchParams.handleexpired" @change="setDate">
                                                <span>超时处理</span>
                                                <el-tooltip style="margin-right: 4px;" effect="light" placement="top" popper-class="event-tip">
                                                    <i class="el-icon-info"></i>
                                                    <template #content>
                                                        <div>1.超过8小时未提交处理且无追踪记录。</div>
                                                        <div>2.未超过8小时且有追踪记录，但7天内无追踪记录的。</div>
                                                    </template>
                                                </el-tooltip>
                                            </el-checkbox>
                                        </el-form-item>
                                    </el-col>
                                </el-row>

                            </el-form>
                        </AthubDropDownSearch>
                    </div>

                    <div v-if="statusHidden" class="advanced-search-location">
                        <span style="color: red">{{ formatworkStatus(workStatus) }}</span>
                    </div>
                    <el-tabs v-model="activeTab" @tab-click="handle_tab_click">
                        <el-tab-pane label="列表" name="table_tab">
                            <el-row class="bottom20">
                                <el-table :data="tableData" v-loading="tableLoading" stripe style="width: 100%"
                                          @selection-change="handleSelectionChange">
                                    <el-table-column
                                        v-if="!btnOpenBatchCancelVisible"
                                        :selectable="checkSelectable"
                                        type="selection"
                                        width="55">
                                    </el-table-column>
                                    <el-table-column label="事件编号" min-width="8%">
                                        <template slot="header" slot-scope="scope">
                                            事件编号<br>
                                            <el-input size="mini"
                                                      v-model="searchParams.ticketid"></el-input>
                                        </template>
                                        <template slot-scope="scope">
                                            <el-button @click="queryDetail(scope.row)" type="text" size="mini">
                                                {{ (scope.row.ticketid) }}
                                            </el-button>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="数据中心" min-width="7%">
                                        <template slot="header" slot-scope="scope">
                                            数据中心<br>
                                            <SysroomSelectNew v-model="searchParams.dcnum"
                                            :filterDcIds="filterDcIds"
                                                              @fetchAllSysrooms="fetchAllSysrooms"
                                                              @sysroomClear="sysroomClear" clearable filterable
                                                              size="mini"></SysroomSelectNew>
                                        </template>
                                        <template slot-scope="scope">
                                            {{ formatRoom(scope.row.dcnum) }}
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="description" label="事件主题" min-width="20%">
                                        <template slot="header" slot-scope="scope">
                                            事件主题<br>
                                            <el-input size="mini"
                                                      v-model="searchParams.description"></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="事件等级" min-width="8%">
                                        <template slot="header" slot-scope="scope">
                                            事件等级<br>
                                            <dictionary-select v-model="searchParams.level" :factory-name="'domain'"
                                                               :params="'TICKETLEVEL'" filterable clearable
                                                               size="mini"></dictionary-select>
                                        </template>
                                        <template slot-scope="scope">
                                            <dictionary-text :factory-name="'domain'" :params="'TICKETLEVEL'"
                                                             :value="scope.row.level"></dictionary-text>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="actualstart" label="开始时间" min-width="18%">
                                        <template slot="header" slot-scope="scope">
                                            开始时间<br>
                                            <el-date-picker v-model="searchParams.startTime" placeholder="开始时间从"
                                            size="small"
                                            format="yyyy-MM-dd"
                                            value-format="yyyy-MM-dd"
                                            class="custom-date-picker"
                                            style="width: 136px;"
                                        />
                                            ~
                                        <el-date-picker
                                            v-model="searchParams.endTime"
                                            placeholder="到"
                                            size="small"
                                            format="yyyy-MM-dd"
                                            value-format="yyyy-MM-dd"
                                            class="custom-date-picker"
                                            style="width: 136px;"/>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="enterby" label="录入人员" min-width="7%">
                                        <template slot="header" slot-scope="scope">
                                            录入人员<br>
                                            <el-input size="mini"
                                                      v-model="searchParams.enterby"></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="事件状态" min-width="7%">
                                        <template slot="header" slot-scope="scope">
                                            事件状态<br>
                                            <dictionary-select v-model="searchParams.status" @loaded="loaded"
                                                               :factory-name="'domain'" :params="'INCIDENTSTATUS'"
                                                               collapseTags multiple filterable clearable
                                                               size="mini"></dictionary-select>
                                        </template>
                                        <template slot-scope="scope">
                                            <dictionary-text :factory-name="'domain'" :params="'INCIDENTSTATUS'"
                                                             :value="scope.row.status"></dictionary-text>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="事件报告" min-width="6%">
                                        <template slot="header" slot-scope="scope">
                                            事件报告<br>
                                            <el-select v-model="searchParams.hasReport" size="mini" placeholder="请选择"
                                                       clearable>
                                                <el-option
                                                    v-for="item in eventReports"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </template>

                                        <template slot-scope="scope">
                                            <div v-if="scope.row.reportNum == ''">
                                                {{ '-' }}
                                            </div>
                                            <div v-if="scope.row.reportNum != ''">
                                                <el-button @click="getRptByReportnum(scope.row)" type="text"
                                                           size="mini">
                                                    <i class="el-icon-document">
                                                    </i>
                                                </el-button>
                                            </div>
                                        </template>
                                    </el-table-column>


                                </el-table>
                            </el-row>
                        </el-tab-pane>
                        <el-tab-pane label="详情" name="detail_tab">
                            <div>
                                <ticket-detail ref="ticketDetail" :ticketId="selectedTicketId"
                                               @loadedEventInfos="loadedEventInfos"></ticket-detail>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane label="关联" name="relation_tab">
                            <relation ref="relationRef"
                                      master="INCIDENT"
                                      :masterKey="selectedTicketId"
                                      :rooms="rooms"
                                      :assetId="ticketEntity.assetid"
                                      :assetTag="ticketEntity.assetDescription"
                                      :roomId="ticketEntity.dcnum"
                                      :level="ticketEntity.level"
                                      :location="ticketEntity.location"
                                      :tickettype="ticketEntity.tickettype"
                                      :failurecode="ticketEntity.failurecode"
                                      :failuretype="ticketEntity.failuretype"
                                      :problemcode="ticketEntity.problemcode"
                                      :source="ticketEntity.source"
                                      :orgid="ticketEntity.orgid"
                                      :siteid="ticketEntity.siteid"
                                      :description="ticketEntity.description"
                                      :memo="ticketEntity.memo"
                                      :actualstart="ticketEntity.actualstart"
                                      @afterQueryRelation="afterQueryRelation">
                            </relation>
                            <span slot="label">关联&nbsp;&nbsp; <span
                                v-show="relationShow">{{ relationNums }}</span></span>
                        </el-tab-pane>
                    </el-tabs>

                </el-row>

                <el-row type="flex" class="row-bg" justify="end" v-if="paginationHidden">
                    <el-pagination align="right" @size-change="handleSizeChange"
                                   @current-change="handleCurrentChange"
                                   :current-page="currentPage"
                                   :page-sizes="pageSizes" :page-size="pageSize"
                                   layout="total, sizes, prev, pager, next, jumper"
                                   :total="total">
                    </el-pagination>
                </el-row>

            </div>
        </div>
        <!--        <LocationDialog ref="LocationPicker"  @change="afterLocationDialogFunc"></LocationDialog>-->
        <!--        <EquipmentDialog ref="EquipmentPicker"  @change="afterEquipmentDialogFunc"></EquipmentDialog>-->
        <EventReportDialog ref="EventReportPicker" @createdReport="createdReport"></EventReportDialog>
        <WorkFlowDialog ref="WorkFlowDialogPicker" :dialogWorkflowVisible.sync="sendFlowVisible"
                        :bussinessId="ticketEntity.ticketuid" bussiness="INCIDENT"
                        :workflowRequestInfo="workflowRequestInfo" statusName="athubStatus"
                        @afterAuditWorkflowFunc="afterAuditWorkflowFunc" @elSelectChangeEvent="elSelectChangeEvent">
            <p slot="customInfo" class="margin-l">
                <el-form label-position="right" label-width="120px"
                         ref="form_workflow_other_info"
                >
                    <el-row v-if="actualfinishShow">
                        <el-col :xs="24" :sm="24" :md="24" :lg="24"><span class="starnotice">*</span>
                            <el-form-item label="事件恢复时间" prop="actualfinish" class="position-relative">
                                <el-date-picker
                                    v-model="sendWorkFlowForm.actualfinish"
                                    size="large"
                                    type="datetime"
                                    format="yyyy-MM-dd HH:mm:ss"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    placeholder="事件恢复时间">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row v-if="levelShow">
                        <el-col :xs="24" :sm="24" :md="12" :lg="12"><span class="starnotice-le">*</span>
                            <el-form-item label="事件等级" prop="level">
                                <dictionary-select v-model="sendWorkFlowForm.level" :factory-name="'domain'"
                                                   :params="'TICKETLEVEL'" filterable clearable size="mini"
                                                   class="position-relative"></dictionary-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row v-if="createShow">
                        <el-col :xs="24" :sm="24" :md="12" :lg="12"><span class="starnotice-cl">*</span>
                            <el-form-item label="创建有效性" prop="workflowCreateValidation">
                                <dictionary-select v-model="sendWorkFlowForm.workflowCreateValidation"
                                                   :factory-name="'domain'" :params="'VALIDATION'" filterable clearable
                                                   size="mini" class="position-relative"></dictionary-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="24" :md="12" :lg="12">
                            <el-form-item label="创建人员" prop="createUser">
                                <el-select v-model="sendWorkFlowForm.createUser" :multiple="true" size="mini"
                                           placeholder="请选择" clearable filterable>
                                    <el-option
                                        v-for="item in createUsers"
                                        :key="item.username"
                                        :label="item.realname"
                                        :value="item.username">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row v-if="handleShow">
                        <el-col :xs="24" :sm="24" :md="12" :lg="12"><span class="starnotice-hl">*</span>
                            <el-form-item label="处理有效性" prop="workflowHandleValidation">
                                <dictionary-select v-model="sendWorkFlowForm.workflowHandleValidation"
                                                   :factory-name="'domain'" :params="'VALIDATION'" filterable clearable
                                                   size="mini" class="position-relative"></dictionary-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="24" :md="12" :lg="12">
                            <el-form-item label="处理人员" prop="handleUser">
                                <el-select v-model="sendWorkFlowForm.handleUser" :multiple="true" size="mini"
                                           placeholder="请选择" clearable filterable>
                                    <el-option
                                        v-for="item in handleUsers"
                                        :key="item.username"
                                        :label="item.realname"
                                        :value="item.username">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </p>
        </WorkFlowDialog>

        <BatchCancelDialog :visible.sync="batchCancelDialogVisible"
                           @loadedEventInfos="loadedEventInfos"
                           :searchParams="batchCancelDialogSearchParams"
                           :selectedCancelTicketIdArr="selectedCancelTicketIdArr">
        </BatchCancelDialog>

        <equipment-table-dialog :visible.sync="dialogSingleEquipmentVisible"
                                :roomId="searchParams.dcnum"
                                :singleFlag="true"
                                @afterSingleSelectFunc="selectedEquipmentHandler">
        </equipment-table-dialog>

        <location-tree-dialog ref="locationTreeDialogRef"
                              :roomId="searchParams.dcnum"
                              :locationTreeDialogVisible.sync="locationTreeDialogVisible"
                              @afterSelectedNode="selectedLocationHandler">
        </location-tree-dialog>

    </div>

</template>

<script type="text/javascript">
import SysroomSelectNew from '@/components/sysroomNew'
import AthubDropDownSearch from '@/components/common/athub.dropdown.search'
import DictionarySelect from '@/components/common/DictionarySelect'
import DictionaryText from '@/components/common/DictionaryText'
import {debounce} from '@/util/common/debounce.js'
import ticketDetail from "@/views/ticket/ticketDetail"
// import LocationDialog from '@/components/common/LocationPicker'
// import EquipmentDialog from '@/components/common/EquipmentPicker'
import WorkFlowDialog from '@/components/workflow/workflowDialog'
import EventReportDialog from '@/views/ticket/eventReportDialog'
import {formatDate} from "element-ui/src/utils/date-util";
import EquipmentTableDialog from "@/views/equipment/point/equipment-table-dialog";
import locationTreeDialog from "@/components/dcim/locationTreeDialog";
import { Message } from 'element-ui';
import _ from 'lodash'
import {
    draftReceivingOrders,
    draftSendWorkFlow,
    draftSendWorkFlowForm,
    exportExcel,
    page,
    queryEventReportHas,
    queryFailurecodes,
    queryFailuretypes,
    queryProblemcodes,
    queryProcessInfos,
    queryStatusByInfo,
    queryTicketEvalList,
    queryTicketType,
} from '@/api/ticket/ticketRestructure/list.js'
import {TICKET_SERVER} from "@/api/server.js";
import {athubAxios} from "@/util/athub-axios/index.js";
import {WorkflowApiNew} from '@/api/workflow/workflow.js'
import CommonServiceApi from '@/api/commonService/index'
import Relation from "@/components/relation/relation";

import BatchCancelDialog from './batchCancelDialog'
import DcimServer from "@/api/dcim";
import dayjs from 'dayjs'

export default {
    name: 'ticket',
    components: {
        AthubDropDownSearch,
        SysroomSelectNew,
        DictionarySelect,
        DictionaryText,
        ticketDetail,
        WorkFlowDialog,
        Relation,
        EventReportDialog,
        BatchCancelDialog,
        EquipmentTableDialog,
        locationTreeDialog,
    },
    data() {
        return {
            relationShow: false,
            //TABLE数据加载转圈圈
            tableLoading: false,
            addClicked: false,
            updateShow: false,//修改按钮是否可见
            tableSelectionShowFlag: false,      //表格第一列撤销是否可见
            btnOpenBatchCancelVisible: true,    //撤销按钮是否可见
            tableSelectedArray: [],             //待撤销列表
            batchCancelDialogVisible: false,    //批量撤销对话框是否可见
            batchCancelDialogSearchParams: {},  //批量撤销表格的查询条件
            selectedCancelTicketIdArr: [],     //待撤销的事件列表
            flagShow: true,//撤销待撤销按钮多一个条件满足显示隐藏
            formCancel: false,//form表单修改取消按钮隐藏显示
            //获取当前有权限的数据中心
            rooms: [],
            filterDcIds: [],
            //事件类型
            tickettypes: [],
            //故障类别
            failuretypes: [],
            //故障现象
            failurecodes: [],
            //问题代码
            problemcodes: [],
            //获取事件状态存储在此集合用于转换中文
            workStatusList: [],
            //页面显示当前工作流状态中文
            workStatus: null,
            //详情页面当前事件ticket对象
            ticketEntity: {},
            //新建按钮隐藏显示
            addShow: true,
            //保存按钮隐藏显示
            saveShow: false,
            //删除按钮隐藏显示
            deleteShow: false,
            //发送工作流按钮是否禁用，防止重复提交
            sendWorkFlowButtonDisabled: false,
            //发送工作流按钮隐藏显示
            sendWorkFlowShow: false,
            //接单按钮是否禁用，防止重复提交
            receivingOrdersDisabled: false,
            //接单按钮隐藏显示
            receivingOrdersShow: false,
            //重新审核按钮隐藏显示
            reexamineShow: false,
            //重新审核按钮是否禁用，防止重复提交
            reexamineDisabled: false,
            //制作事件报告按钮隐藏显示
            eventReportShow: false,
            //制作事件报告按钮是否禁用，防止重复提交
            eventReportDisabled: false,
            //是否可以点击导出按钮，防止重复提交
            exportDisabled: false,
            //导出按钮隐藏显示
            exportExcelShow: true,
            //发送工作流弹窗显示
            sendFlowVisible: null,
            //发送工作流弹窗传入调用工作流 request 返回得信息
            workflowRequestInfo: {},
            searchParams: {
                currentEvent: true,
                ticketid: null,
                dcnum: null,
                description: null,
                level: null,
                enterby: null,
                status: null,
                hasReport: null,
                source: null,
                tickettype: null,
                failuretype: null,
                failurecode: null,
                problemcode: null,
                location: null,
                assetnum: null,
                startTime: null,
                endTime: null,
                acceptexpired: null,
                auditexpired: null,
                handleexpired: null,
                hasChecked: 'NO',

                //盯屏参数
                type: "",
                newTicketIntervalTime: null,
                closedTicketIntervalTime: null,
            },
            searchParamsNotSendBackstage: {
                statusArrs: [],
                locationDescriptionNo: null,
                assetnumDescriptionNo: null,
            },
            eventReports: [{
                value: 'YES',
                label: '有'
            }, {
                value: 'NO',
                label: '无'
            }],//事件报告集合

            //分页根据不同TAB隐藏或者显示
            paginationHidden: true,
            //右上角状态隐藏或者显示
            statusHidden: true,
            //表格翻页查询条件
            currentPage: 1,
            pageSize: 10,
            pageSizes: [10, 25, 50, 100, 1000],
            total: 0,
            //当前Tab页
            activeTab: "table_tab",

            //事件返回数据
            tableData: [],
            //跳转详情页面带过去的ticketid
            selectedTicketId: '',

            relationNums: '',

            //发送工作流页面弹窗的有效性和创建人员和处理人员form
            sendWorkFlowForm: {
                'workflowCreateValidation': 'NEUTRAL',
                'workflowHandleValidation': 'NEUTRAL',
                'createUser': null,
                'handleUser': null,
                'actualfinish': null,
                'level': null,
            },
            //发送工作流页面弹窗创建人集合
            createUsers: [],
            //发送工作流页面弹窗处理人集合
            handleUsers: [],
            //发送工作流弹窗事件等级显示不显示
            levelShow: false,
            //发送工作流弹窗事件处理有效性和处理人员显示不显示
            handleShow: false,
            //发送工作流弹窗事件创建有效性和创建人员显示不显示
            createShow: false,
            //发送工作流弹窗事件恢复时间显示不显示
            actualfinishShow: false,
            Constant: {
                review_flag_process: "重新审核",//用于标识 工作流审批历史 的重新审核阶段对应的名称
                closeWorkflowName: "完工",//事件结束时候的流程节点名称，用于区分是否显示创建有效性
            },
            //查看当前事件是否是重新审核过来的
            ifReview: false,

            dialogSingleEquipmentVisible: false,

            locationTreeDialogVisible: false,
        }

    },

    methods: {
        //查询页面数据中心清空促发事件
        sysroomClear() {
            //显示批量撤单按钮
            this.flagShow = true;
            this.btnOpenBatchCancelVisible = true;
            this.queryTable();
        },
        //查询三个checkbox选中得时候促发事件
        setDate(e) {
            var date = new Date(),
                y = date.getFullYear(),
                m = date.getMonth();
            var firstDay = new Date(y, m, 1);
            var lastDay = new Date(y, m + 1, 0);
            if (e == true) {
                this.searchParams.startTime = formatDate(firstDay, 'yyyy-MM-dd');
                this.searchParams.endTime = formatDate(lastDay, 'yyyy-MM-dd');
            }
        },
        createdReport() {
            this.$refs.ticketDetail.queryTicketDetail(this.ticketEntity.ticketid);
        },
        openBatchCancelDialogHandler() {
            if (this.searchParams.dcnum == null || this.searchParams.dcnum == '') {
                this.$message.error('请选择数据中心!');
                return;
            } else {
                //批量撤单和确认批量撤单和取消按钮多一个条件满足显示隐藏
                this.flagShow = true;
                this.btnOpenBatchCancelVisible = false;
            }
        },

        cancelBatchCancelDialogHandler() {
            this.btnOpenBatchCancelVisible = true;
        },

        confirmBatchCancelHandler() {
            if (this.selectedCancelTicketIdArr.length == 0) {
                this.$message.error('请勾选要撤单的事件信息！');
                return;
            }
            this.batchCancelDialogVisible = true;
            this.batchCancelDialogSearchParams = {
                'source': 'ROUTING',
                'dcnum': this.searchParams.dcnum,
                startTime: this.searchParams.startTime,
                endTime: this.searchParams.endTime,
                'isBatchCancelOrder': 'YES',
            };
        },

        handleSelectionChange(arr) {
            this.selectedCancelTicketIdArr = [];
            for (let i = 0; i < arr.length; i++) {
                this.selectedCancelTicketIdArr.push(arr[i].ticketid);
            }
        },

        afterQueryRelation(relationNums) {
            if (relationNums == 0) {
                this.relationShow = false;
                this.relationNums = "";
            } else {
                this.relationShow = true;
                this.relationNums = "(" + relationNums + ")";
            }
        },

        handle_tab_click(tab, event) {
            this.activeTab = tab.name;
            if (this.workStatus != null && this.ticketEntity.ticketuid != undefined) {
                this.changeActiveTabControl(this.ticketEntity.ticketuid, this.workStatus);
            } else {
                this.changeActiveTabControl();
            }


        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.queryTable();
        },

        handleCurrentChange(val) {
            this.currentPage = val;
            this.queryTable();
        },
        //查询
        async queryTable() {
            if(!this.$route.query.source && !this.$route.query.sourcePage && !this.$route.query.statusList && !this.$route.query.TICKETID && !this.$route.query.incidentGroup && !this.$route.query.processName) {
                if(!this.searchParams.startTime || !this.searchParams.endTime) {
                    Message.closeAll()
                    return this.$message({
                        type:'warning',
                        message: '请选择开始时间和结束时间进行查询'
                    })
                }
            }

            this.tableLoading = true;
            //防止因为searchParam数组转字符串导致watch查询两次，这边在最后要发出参数得时候在给他转换一下
            let routeParams = {...this.$route.query}
            let finalRouteParams = {}
            if(routeParams.sourcePage === 'bigScreen') {
                if(routeParams.type)
                    finalRouteParams.type = routeParams.type
                if(routeParams.source)
                    finalRouteParams.source = routeParams.source
                if(routeParams.sourcePage)
                    finalRouteParams.sourcePage = routeParams.sourcePage
            }
            let data = $.extend({}, this.searchParams, finalRouteParams);

            //let data=this.searchParams;
            //防止只是把对象引用赋值给新得值
            if (data.status != null && data.status.length > 0) {
                data.status = data.status.join(",");
            } else {
                data.status = null;
            }

            var param = {
                'iDisplayStart': this.currentPage,
                'iDisplayLength': this.pageSize,
                'conditions': JSON.stringify({
                    ...data,
                }),
                'appId': 'WEB',
                'token': localStorage.getItem("token")
            };
            var responseBody = await page(param);
            this.tableLoading = false;
            this.total = responseBody.iTotalRecords;
            this.tableData = responseBody.aaData;

            // this.$refs.LocationPicker.isTure = false;
        },
        //根据下划线获取事件类型第二段信息
        isSplitValue(typeValue) {
            if (typeValue != null && typeValue.trim() != "") {
                return typeValue.split('_')[1];
            } else {
                return typeValue;
            }
        },
        //事件类型促发事件
        async tickettypeChange() {

            this.searchParams.failuretype = null;
            this.failuretypes = await queryFailuretypes(this.searchParams.tickettype);

        },
        //故障类别促发事件
        async failuretypeChange() {
            this.searchParams.failurecode = null;
            this.failurecodes = await queryFailurecodes(this.searchParams.failuretype);
        },
        //故障现象促发事件
        async failurecodeChange() {
            this.searchParams.problemcode = null;
            this.problemcodes = await queryProblemcodes(this.searchParams.failurecode);
        },
        //位置删除按钮
        deleteLaction() {
            this.searchParams.location = null;
            this.searchParamsNotSendBackstage.locationDescriptionNo = null;
        },
        //位置打开按钮
        openLaction() {
            // this.$refs.LocationPicker.dialogVisible=true;
            // this.$refs.LocationPicker.pageSearch.search.roomid=this.searchParams.dcnum;
            // this.$refs.LocationPicker.queryByPage();

            if (this.searchParams.dcnum == null || this.searchParams.dcnum == '') {
                this.$message.error('请先选择数据中心!');
            } else {
                this.locationTreeDialogVisible = true;
            }
        },
        //设备打开按钮
        openEquipment() {
            // this.$refs.EquipmentPicker.dialogVisible=true;
            // this.$refs.EquipmentPicker.pageSearch.search.roomId=this.searchParams.dcnum;
            // this.$refs.EquipmentPicker.pageSearch.search.appId='WEB';
            // this.$refs.EquipmentPicker.pageSearch.search.token=localStorage.getItem("token");
            // if(this.searchParams.failuretype!=null){
            //     this.$refs.EquipmentPicker.pageSearch.search.assetType=this.searchParams.failuretype;
            // }
            // this.$refs.EquipmentPicker.queryByPage();

            if (this.searchParams.dcnum == null || this.searchParams.dcnum == '') {
                this.$message.error('请先选择数据中心!');
            } else {
                this.dialogSingleEquipmentVisible = true;
            }
        },
        //设备删除按钮
        deleteEquipment() {
            this.searchParams.assetnum = null;
            this.searchParamsNotSendBackstage.assetnumDescriptionNo = null;
        },
        //位置弹出框点击确定按钮
        afterLocationDialogFunc(row) {
            this.searchParams.location = row.location;
            this.searchParamsNotSendBackstage.locationDescriptionNo = row.description;
        },
        //设备弹出框点击确定按钮
        // afterEquipmentDialogFunc(row){
        //
        //     this.searchParams.assetnum=row.assetId;
        //     this.searchParamsNotSendBackstage.assetnumDescriptionNo=row.assetTag;
        // },
        //跳转事件报告
        getRptByReportnum(row) {
            var url = process.env.VUE_APP_WEB_API + "/athub" + "/event/report.html?reportnum=" + row.reportNum + "&appId=WEB&token=" + localStorage.getItem("token");
            window.open(url);
        },
        //详细页面回调主页面赋值当前工作流状态
        loadedEventInfos(info) {
            if (info == null) {   //删除事件
                this.activeTab = 'table_tab';
                this.currentPage = 1;
                this.changeActiveTabControl();

            } else {
                this.workStatus = info.ticket.status;//页面显示工作流状态
                this.ticketEntity = info.ticket;//ticket实体
                //重新隐藏或者显示相关按钮
                this.setButtonStatus(this.workStatus);
                this.changeActiveTabControl(info.ticket.ticketuid, info.ticket.status);
                this.selectedTicketId = info.ticket.ticketid;
            }


            //this.selectedTicketId = null;
        },
        fetchAllSysrooms(rooms) {
            //rooms页面存储变量,供:formatter="formatRoom"循环转换TABLE对应的中文
            rooms.map(e => {
                e.id = e.id.toString();
            })
            this.rooms = rooms;
        },
        //查询TABLE页面数据中心转换成文字
        formatRoom(dcnum) {
            let roomDesc = '';
            this.rooms.forEach(e => {
                if (dcnum == e.id) {
                    roomDesc = e.name;
                }
            });
            return roomDesc;
        },
        loaded(infos) {
            //页面存储事件状态供formatworkStatus循环转换中文
            this.workStatusList = infos.items;
        },
        //页面根据时间状态显示中文子转换方法
        formatworkStatus(info) {
            let statusDesc = '';
            this.workStatusList.forEach(e => {
                if (info == e.value) {
                    statusDesc = e.description;
                }
            });
            return statusDesc;
        },
        //TAB切换
        async changeActiveTabControl(ticketuid, rowStatus) {

            if (this.activeTab == 'table_tab') {
                this.tableLoading = true
                if(this.$route.query.source && this.$route.query.source === 'index') {
                    await this.getMonitorIds()
                }
                await this.queryTable();
                //分页
                this.paginationHidden = true;
                //右上角状态
                this.statusHidden = false;
                //隐藏工作流相关按钮
                this.hiddenButton();
                //导出按钮
                this.exportExcelShow = true;
                //新增按钮
                this.addShow = true;
                //修改按钮
                this.updateShow = false;
                //保存按钮
                this.saveShow = false;
                //删除按钮
                this.deleteShow = false;
                //form表单修改取消按钮
                this.formCancel = false;
                //批量撤单和确认批量撤单和取消按钮
                this.btnOpenBatchCancelVisible = true;
                //确认批量撤单和取消按钮多一个条件满足显示隐藏
                this.flagShow = false;
            } else if (this.activeTab == 'detail_tab') {//详情
                this.hiddenButton();
                if (this.workStatus) {
                    this.setButtonStatus(this.workStatus);
                }
                //分页
                this.paginationHidden = false;
                //右上角状态
                this.statusHidden = true;
                //导出按钮
                this.exportExcelShow = false;

                if (ticketuid == undefined) {//新增
                    //新增按钮
                    this.addShow = false;
                    //保存按钮
                    this.saveShow = true;
                    //修改按钮
                    this.updateShow = false;
                    //删除按钮
                    this.deleteShow = false;
                    //form表单修改取消按钮
                    this.formCancel = false;
                    //批量撤单和确认批量撤单和取消按钮
                    this.btnOpenBatchCancelVisible = false;
                    //批量撤单和确认批量撤单和取消按钮多一个条件满足显示隐藏
                    this.flagShow = false;
                } else {//修改

                    if (rowStatus == 'DRAFT') {//草稿显示按钮
                        //新增按钮
                        this.addShow = false;
                        //修改按钮
                        this.updateShow = true;
                        //保存按钮
                        this.saveShow = false;
                        //删除按钮
                        this.deleteShow = true;
                        //form表单修改取消按钮
                        this.formCancel = false;
                        //批量撤单和确认批量撤单和取消按钮
                        this.btnOpenBatchCancelVisible = false;
                        //批量撤单和确认批量撤单和取消按钮多一个条件满足显示隐藏
                        this.flagShow = false;
                    }
                    if (rowStatus == 'WACCEPT') {//待接单显示按钮
                        //新增按钮
                        this.addShow = false;
                        //修改按钮
                        this.updateShow = false;
                        //保存按钮
                        this.saveShow = false;
                        //删除按钮
                        this.deleteShow = false;
                        //form表单修改取消按钮
                        this.formCancel = false;
                        //批量撤单和确认批量撤单和取消按钮
                        this.btnOpenBatchCancelVisible = false;
                        //批量撤单和确认批量撤单和取消按钮多一个条件满足显示隐藏
                        this.flagShow = false;
                    }
                    if (rowStatus == 'WHANDLE') {//待处理显示按钮
                        //新增按钮
                        this.addShow = false;
                        //修改按钮
                        this.updateShow = true;
                        //保存按钮
                        this.saveShow = false;
                        //删除按钮
                        this.deleteShow = false;
                        //form表单修改取消按钮
                        this.formCancel = false;
                        //批量撤单和确认批量撤单和取消按钮
                        this.btnOpenBatchCancelVisible = false;
                        //批量撤单和确认批量撤单和取消按钮多一个条件满足显示隐藏
                        this.flagShow = false;
                    }

                    if (rowStatus == 'WAPPR') {//待审批显示按钮
                        //新增按钮
                        this.addShow = false;
                        //修改按钮
                        this.updateShow = true;
                        //保存按钮
                        this.saveShow = false;
                        //删除按钮
                        this.deleteShow = false;
                        //form表单修改取消按钮
                        this.formCancel = false;
                        //批量撤单和确认批量撤单和取消按钮
                        this.btnOpenBatchCancelVisible = false;
                        //批量撤单和确认批量撤单和取消按钮多一个条件满足显示隐藏
                        this.flagShow = false;
                    }
                    if (rowStatus == 'CLOSE') {//已关闭显示按钮
                        //新增按钮
                        this.addShow = false;
                        //修改按钮
                        this.updateShow = false;
                        //保存按钮
                        this.saveShow = false;
                        //删除按钮
                        this.deleteShow = false;
                        //form表单修改取消按钮
                        this.formCancel = false;
                        //批量撤单和确认批量撤单和取消按钮
                        this.btnOpenBatchCancelVisible = false;
                        //批量撤单和确认批量撤单和取消按钮多一个条件满足显示隐藏
                        this.flagShow = false;
                    }
                    if (rowStatus == 'DELETED' || rowStatus == 'CANCEL') {//已删除或者以撤单显示按钮
                        //新增按钮
                        this.addShow = false;
                        //修改按钮
                        this.updateShow = false;
                        //保存按钮
                        this.saveShow = false;
                        //删除按钮
                        this.deleteShow = false;
                        //form表单修改取消按钮
                        this.formCancel = false;
                        //批量撤单和确认批量撤单和取消按钮
                        this.btnOpenBatchCancelVisible = false;
                        //批量撤单和确认批量撤单和取消按钮多一个条件满足显示隐藏
                        this.flagShow = false;
                    }
                    if (rowStatus == 'RECOVER') {
                        //新增按钮
                        this.addShow = false;
                        //修改按钮
                        this.updateShow = false;
                        //保存按钮
                        this.saveShow = false;
                        //删除按钮
                        this.deleteShow = false;
                        //form表单修改取消按钮
                        this.formCancel = false;
                        //批量撤单和确认批量撤单和取消按钮
                        this.btnOpenBatchCancelVisible = false;
                        //批量撤单和确认批量撤单和取消按钮多一个条件满足显示隐藏
                        this.flagShow = false;
                    }
                }


            } else {//关联
                this.hiddenButton();
                //分页
                this.paginationHidden = false;
                //右上角状态
                this.statusHidden = false;
                //导出按钮
                this.exportExcelShow = false;
                //修改按钮
                this.updateShow = false;
                //新增按钮
                this.addShow = false;
                //保存按钮
                this.saveShow = false;
                //删除按钮
                this.deleteShow = false;
                //form表单修改取消按钮
                this.formCancel = false;
                //批量撤单和确认批量撤单和取消按钮
                this.btnOpenBatchCancelVisible = false;
                //批量撤单和确认批量撤单和取消按钮多一个条件满足显示隐藏
                this.flagShow = false;
            }
        },
        addFunc() {
            this.activeTab = 'detail_tab';
            //清空右上角状态和详情实体ticketEntity
            this.workStatus = null;
            this.ticketEntity = {};
            this.changeActiveTabControl();
            this.$refs['ticketDetail'].init();
            this.addClicked = true;

            //隐藏详情里面的按钮和信息
            this.$refs.ticketDetail.hasReport = false;
            this.relationShow = false;
        },
        async queryDetail(row) {
            this.activeTab = 'detail_tab';
            this.changeActiveTabControl(row.ticketuid, row.status);
            this.addClicked = false;
            if (this.selectedTicketId == row.ticketid) {
                this.$refs.ticketDetail.queryTicketDetail(row.ticketid);
            } else {
                this.selectedTicketId = row.ticketid;
            }
            this.relationShow = true;

            this.$refs['relationRef'].queryPageOper(this.selectedTicketId);
        },
        async saveFunc() {
            if (await this.$refs.ticketDetail.saveCheck()) {
                if (await this.$refs.ticketDetail.save()) {
                    this.$refs['ticketDetail'].formDisable = true;
                    //修改按钮
                    this.updateShow = true;
                    //发送工作流按钮
                    this.sendWorkFlowShow = true;
                    //form表单修改取消按钮
                    this.formCancel = false;
                    //保存按钮
                    this.saveShow = false;
                    if (this.workStatus == 'DRAFT') {
                        //删除按钮
                        this.deleteShow = true;
                    } else {
                        //删除按钮
                        this.deleteShow = false;
                    }
                    //            //保存之后此字段 要设置成true
                    this.addClicked = false;
                } else {
                    this.$refs['ticketDetail'].formDisable = false;
                    //修改按钮
                    this.updateShow = false;
                    //发送工作流按钮
                    this.sendWorkFlowShow = false;
                    //form表单修改取消按钮
                    this.formCancel = false;
                    //保存按钮
                    this.saveShow = true;
                    //删除按钮
                    this.deleteShow = false;
                }
            }
        },

        btnDelClickHandle() {
            this.$confirm('确定删除？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$refs.ticketDetail.delete();

            })

        },

        //发送工作流
        async sendWorkFlow() {
            //判断当前状态和数据库是否一致
            var responseDataInfo = await queryStatusByInfo(this.ticketEntity);
            if (responseDataInfo == 0) {
                this.$message.success('事件状态已更新，请刷新页面再操作！');
                return;
            }
            //        var a=this.ticketEntity;

            if (null != this.workStatus && this.workStatus != '') {
                //监控系统接入事件部分字段可能为空，为避免事件报告不能制作成功，需要在事件待处理或待审批流程中加入必输项校验
                if (this.workStatus == "WAPPR" || this.workStatus == "WHANDLE") {
                    if (!this.checkoutParameter()) {
                        return;
                    }

                }
                //防止重复提交
                this.sendWorkFlowButtonDisabled = true;
                let bussiness = this.ticketEntity.enterbyusername == 'incident' ? 'INCIDENT3' : 'INCIDENT'
                var business = {
                    'bussiness': bussiness,
                    'bussinessId': this.ticketEntity.ticketuid,
                    'params': JSON.stringify({
                        'room_id': this.ticketEntity.dcnum,
                        'STATUS': this.workStatus,
                        'TITLE': this.ticketEntity.description,
                        'TICKETID': this.ticketEntity.ticketid,
                    }),
                    "token": localStorage.getItem("token"),
                    "appId": "WEB"
                };
                var response;
                try {
                  response = await WorkflowApiNew.request(business);


                  //针对草稿状态不弹框，直接发送到工作流和针对除去草稿状态的直接弹框，然后进行处理
                  /*if(response.code=="ERROR"||response.code=="CLOSED"){
                      this.$message.success(response.message);
                      this.sendWorkFlowButtonDisabled=false;
                      return;
                  }*/
                  var busineesId = response.ownerId;
                  var wfToken = response.wfToken;
                  var json = eval(response.node_info.nextNodes);
                  if (this.workStatus == "DRAFT") {
                      var nextNodeId = json[0].id;
                      //发送工作流参数
                      var jsonData = {
                          'token': localStorage.getItem("token"),
                          'appId': "WEB",
                          'params': business.params,
                          'nextNodeId': nextNodeId,
                          'wfToken': wfToken
                      }
                      //后台更新 ticket得参数
                      var submitParam = {
                          "ticketUid": busineesId,
                          "ticketid": this.ticketEntity.ticketid,
                          "status": this.workStatus,
                          "nextStatus": null,//后台赋值
                          "level": null,
                          "actualfinish": null,
                          "createValidation": null,
                          "createUser": [],
                          "handleValidation": null,
                          "handleUser": []
                      }
                      jsonData.dto = JSON.stringify(submitParam);

                      //前台调用工作流之后调用后台ticket/submit接口换成两个步骤直接调用ticket在从ticket在去调用工作流的项目，因为需要支持分布式事务
                      //INCIDENT3为新的事件工作流类型，监控系统接入时不调用工作流接口
                      let bussiness = this.ticketEntity.enterbyusername == 'incident' ? 'INCIDENT3' : 'INCIDENT'
                      var requestUrl = "/ticket/ticketToWorkFlowAudit/" + bussiness + "/" + busineesId;
                      var message = await draftSendWorkFlow(requestUrl, jsonData);
                      this.sendWorkFlowButtonDisabled = false;
                      this.$message.success(message);
                      //刷新查询页面得右上角得工作流状态

                      this.$refs.ticketDetail.queryTicketDetail(this.ticketEntity.ticketid);
                      //刷新流转信息
                      this.$refs['ticketDetail'].$refs['ticketWorkflowInfoRef'].getHistoryList();

                      //修改按钮
                      this.updateShow = false;
                      //删除按钮
                      this.deleteShow = false;


                  } else {
                      this.sendWorkFlowButtonDisabled = false;
                      //弹框：初始化框里的内容
                      this.initWorkflowModal(response, business.params);
                  }
              } catch (error) {
                console.log(error)
                this.$message.error(error);
                this.sendWorkFlowButtonDisabled = false;
              }
            } else {
                this.$message.success('请先保存事件信息再发送工作流!');
            }
        },
        //发送工作流校验字段是否有值
        checkoutParameter() {
            if (this.isDataEmpty(this.ticketEntity.ticketid)) {
                this.$message.success('事件编号必填项！');
                return false;
            }
            if (this.isDataEmpty(this.ticketEntity.dcnum)) {
                this.$message.success('数据中心必填项！');
                return false;
            }
            if (this.isDataEmpty(this.ticketEntity.memo)) {
                this.$message.success('事件详情必填项!');
                return false;
            }
            if (this.isDataEmpty(this.ticketEntity.actualstart)) {
                this.$message.success('事件开始时间必填项!');
                return false;
            }
            if (this.isDataEmpty(this.ticketEntity.source)) {
                this.$message.success('事件来源必填项!');
                return false;
            }
            if (this.isDataEmpty(this.ticketEntity.description)) {
                this.$message.success('事件主题必填项!');
                return false;
            }
            if (this.isDataEmpty(this.ticketEntity.level)) {
                this.$message.success('事件等级必填项!');
                return false;
            }
            if (this.isDataEmpty(this.ticketEntity.tickettype)) {
                this.$message.success('事件类型必填项!');
                return false;
            }
            if (this.isDataEmpty(this.ticketEntity.failuretype)) {
                this.$message.success('故障类别必填项!');
                return false;
            }
            if (this.ticketEntity.level == 'LEVEL1' || this.ticketEntity.level == 'LEVEL2') {
                if (this.isDataEmpty(this.ticketEntity.failurecode) || this.isDataEmpty(this.ticketEntity.problemcode)) {
                    this.$message.success('一、二级事件故障现象/故障原因必填项!');
                    return false;
                }
            }
            if (!this.isDataEmpty(this.ticketEntity.actualfinish)) {
                if (this.isDateNotValid(this.ticketEntity.actualstart, this.ticketEntity.actualfinish)) {
                    this.$message.success('开始时间要小于等于事件恢复时间!');
                    return false;
                }
            }
            if (this.isDataEmpty(this.ticketEntity.enterby)) {
                this.$message.success('录入人员必填项！');
                return false;
            }
            return true;
        },
        isDataEmpty(dataInfo) {
            if (dataInfo == null || dataInfo == "" || dataInfo == undefined) {
                return true;
            } else {
                return false;
            }
        },
        isDateNotValid: function (startDate, endDate) {
            if (Date.parse(startDate) <= Date.parse(endDate)) {
                return false;
            } else {
                return true;
            }
        },
        //除了草稿和接单以外的发送工作流初始化弹窗
        async initWorkflowModal(response, param) {
            //显示或者隐藏弹窗某一些字段
            //1.先集体隐藏在根据不同状态是否需要显示
            //发送工作流弹窗事件等级显示不显示
            this.levelShow = false;
            //发送工作流弹窗事件处理有效性和处理人员显示不显示
            this.handleShow = false;
            //发送工作流弹窗事件创建有效性和创建人员显示不显示
            this.createShow = false;
            //发送工作流弹窗事件恢复时间显示不显示
            this.actualfinishShow = false;

            //清空插槽里面的值
            this.sendWorkFlowForm.actualfinish = null;
            this.sendWorkFlowForm.level = null;
            this.sendWorkFlowForm.createUser = null;
            this.sendWorkFlowForm.handleUser = null;
            this.sendWorkFlowForm.workflowCreateValidation = 'NEUTRAL';
            this.sendWorkFlowForm.workflowHandleValidation = 'NEUTRAL';
            //打开弹窗
            this.sendFlowVisible = true;
            this.workflowRequestInfo = response;
            this.workflowRequestInfo.nodeInfo = this.workflowRequestInfo.node_info;
            //赋值创建人和处理人

            var response = await CommonServiceApi.getSysuserList(this.ticketEntity.dcnum);
            this.createUsers = response.data;
            this.handleUsers = response.data;

            //事件恢复时间如果没有值赋值当前事件如果有值获取详情里面的事件赋值
            if (null != this.ticketEntity.actualfinish && this.ticketEntity.actualfinish != '') {
                this.sendWorkFlowForm.actualfinish = this.ticketEntity.actualfinish;
            } else {
                this.sendWorkFlowForm.actualfinish = formatDate(new Date(), 'yyyy-MM-dd HH:mm:ss');
            }
            //事件等级获取详情里面的等级赋值
            this.sendWorkFlowForm.level = this.ticketEntity.level;

            //获取流转信息查看是否有重新审核过
            var url = "/ticket/workflowInfo/" + this.ticketEntity.ticketuid + "?appId=WEB&token=" + localStorage.getItem("token");
            var infos = await queryProcessInfos(url);
            if (infos.code == '200' && infos.data != null) {
                var info = JSON.stringify(infos.data)
                if (info.indexOf(this.Constant.review_flag_process) != -1) {
                    this.ifReview = true;
                }
            }

            //2.根据不同状态显示
            if (this.workStatus == 'WHANDLE') {
                this.levelShow = false;
                this.createShow = true;
                this.handleShow = true;
                this.actualfinishShow = true;
            } else if (this.workStatus == 'WAPPR') {
                this.levelShow = true;
                this.actualfinishShow = true;
                this.createShow = true;
                this.handleShow = true;

                //顺带加载待处理保存得时候选择得创建人和处理人
                var url = "/ticket/" + this.ticketEntity.ticketid + "?appId=WEB&token=" + localStorage.getItem("token");
                var evalInfo = await queryTicketEvalList(url, null);
                var evalList = evalInfo.result.ticketEvalList;

                if (null != evalList && evalList.length > 0) {
                    for (var i = 0; i < evalList.length; i++) {
                        if (evalList[i].ticketevaltype != '') {
                            if (evalList[i].ticketevaltype == "DISCOVER") {
                                this.sendWorkFlowForm.workflowCreateValidation = evalList[i].validation;
                                if (evalList[i].evalby != null && evalList[i].evalby != '') {
                                    this.sendWorkFlowForm.createUser = evalList[i].evalby.split(',');
                                }

                            } else {
                                this.sendWorkFlowForm.workflowHandleValidation = evalList[i].validation;
                                if (evalList[i].evalby != null && evalList[i].evalby != '') {
                                    this.sendWorkFlowForm.handleUser = evalList[i].evalby.split(',');
                                }

                            }
                        }
                    }
                }

            } else if (this.workStatus == 'CLOSE') {
                //顺带加载待处理保存得时候选择得创建人和处理人
                var url = "/ticket/" + this.ticketEntity.ticketid + "?appId=WEB&token=" + localStorage.getItem("token");
                var evalInfo = await queryTicketEvalList(url, null);
                var evalList = evalInfo.result.ticketEvalList;

                if (null != evalList && evalList.length > 0) {
                    for (var i = 0; i < evalList.length; i++) {
                        if (evalList[i].ticketevaltype != '') {
                            if (evalList[i].ticketevaltype == "DISCOVER") {
                                this.sendWorkFlowForm.workflowCreateValidation = evalList[i].validation;
                                if (evalList[i].evalby != null && evalList[i].evalby != '') {
                                    this.sendWorkFlowForm.createUser = evalList[i].evalby.split(',');
                                }

                            } else {
                                this.sendWorkFlowForm.workflowHandleValidation = evalList[i].validation;
                                if (evalList[i].evalby != null && evalList[i].evalby != '') {
                                    this.sendWorkFlowForm.handleUser = evalList[i].evalby.split(',');
                                }

                            }
                        }
                    }
                }
            }


        },
        //关闭所有按钮
        hiddenButton() {
            this.sendWorkFlowShow = false;
            this.receivingOrdersShow = false;
            this.reexamineShow = false;
            this.eventReportShow = false;
        },
        //判断当前状态显示按钮得隐藏或者显示
        setButtonStatus(curttenStatus) {

            //先全部隐藏按钮在根据不同状态开启不同按钮
            this.hiddenButton();
            if (curttenStatus == 'DRAFT') {  //草稿
                this.sendWorkFlowShow = true;//发送工作流按钮

            } else if (curttenStatus == 'WACCEPT') { //待接单
                this.receivingOrdersShow = true;//接单按钮

            } else if (curttenStatus == 'WHANDLE') {//待处理
                this.sendWorkFlowShow = true;//发送工作流按钮

            } else if (curttenStatus == 'WAPPR') {//待审批
                this.sendWorkFlowShow = true;//发送工作流按钮

            } else if (curttenStatus == 'SUSPEND') {//挂起中
                //            $("#updateTicketInfo").show();//修改
                //            $("#sendWorkflowFirst").show();//发送工作流

            } else if (curttenStatus == 'CLOSE') {//已关闭[关闭状态情况下，只显示重新审核和制作数据报告]
                this.eventReportShow = true;//制作事件报告
                this.reexamineShow = true;//重新审核

            } else if (curttenStatus == 'CANCEL') { //已撤销

            } else if (curttenStatus == 'DELETED') {//已删除

            } else if (curttenStatus == 'MASKED') {// NOTE: 已屏蔽，置灰
                this.sendWorkFlowButtonDisabled = true;
            }
        },
        //接单
        async receivingOrders() {
            //监控系统接入，INCIDENT3为新的事件工作流类型，监控系统接入时不调用工作流接口
            if (this.ticketEntity.enterbyusername == 'incident') {
                if(!this.ticketEntity.dcnum) {
                    this.$message.warning('数据中心不能为空!');
                    return
                }

                this.receivingOrdersDisabled = true;
                let business = {
                    'bussiness': 'INCIDENT3',
                    'bussinessId': this.ticketEntity.ticketuid,
                    'params': JSON.stringify({
                        'room_id': this.ticketEntity.dcnum,
                        'STATUS': this.workStatus,
                        'TITLE': this.ticketEntity.description,
                        'TICKETID': this.ticketEntity.ticketid,
                    }),
                    "token": localStorage.getItem("token"),
                    "appId": "WEB"
                };
                let response;
                try {
                    response = await WorkflowApiNew.request(business);
                } catch (error) {
                    this.$message.error(error);
                    this.receivingOrdersDisabled = false;
                    return;
                }
                let busineesId = response.ownerId;
                let wfToken = response.wfToken;
                let json = eval(response.node_info.nextNodes);
                let nextNodeId = json[0].id;

                //发送工作流参数
                var jsonData = {
                    'token': localStorage.getItem("token"),
                    'appId': "WEB",
                    'params': business.params,
                    'nextNodeId': nextNodeId,
                    'wfToken': wfToken
                }
                //后台更新 ticket得参数
                var submitParam = {
                    "ticketUid": busineesId,
                    "ticketid": this.ticketEntity.ticketid,
                    "status": this.workStatus,
                    "nextStatus": null,//后台赋值
                    "level": null,
                    "actualfinish": null,
                    "createValidation": null,
                    "createUser": [],
                    "handleValidation": null,
                    "handleUser": []
                }
                jsonData.dto = JSON.stringify(submitParam);

                //前台调用工作流之后调用后台ticket/submit接口换成两个步骤直接调用ticket在从ticket在去调用工作流的项目，因为需要支持分布式事务
                let requestUrl = "/ticket/ticketToWorkFlowAudit/INCIDENT3/" + busineesId;
                try {
                    let message = await draftSendWorkFlow(requestUrl, jsonData);
                    this.receivingOrdersDisabled = false;
                    this.$message.success(message);

                    //刷新查询页面得右上角得工作流状态
                    this.$refs.ticketDetail.queryTicketDetail(this.ticketEntity.ticketid);
                    //刷新流转信息
                    this.$refs['ticketDetail'].$refs['ticketWorkflowInfoRef'].getHistoryList();

                    this.receivingOrdersShow = false;
                    this.sendWorkFlowShow = true;

                    //修改按钮
                    this.updateShow = true;
                    //删除按钮
                    this.deleteShow = false;
                } catch (error) {
                    this.receivingOrdersDisabled = false;
                    this.$message.error(error);
                }
            } else {
                if (null != this.workStatus && this.workStatus != '') {
                    //防止重复提交
                    this.receivingOrdersDisabled = true;
                    var jsonStr = {
                        'room_id': this.ticketEntity.dcnum.toString(),
                        'TITLE': this.ticketEntity.description,
                        'TICKETID': this.ticketEntity.ticketid,
                    }

                    var param = JSON.stringify(jsonStr);
                    var busineesId = this.ticketEntity.ticketuid;

                    var formData = {
                        'token': localStorage.getItem("token"),
                        'appId': "WEB",
                        'params': param,
                    }


                    var submitParam = {
                        "ticketUid": busineesId,
                        "ticketid": this.ticketEntity.ticketid,
                        "status": this.workStatus,
                        "nextStatus": null,//后台赋值
                        "level": null,
                        "actualfinish": null,
                        "createValidation": null,
                        "createUser": [],
                        "handleValidation": null,
                        "handleUser": []
                    }

                    formData.dto = JSON.stringify(submitParam);
                    //换成调用ticket在从ticket在去调用工作流的项目，因为需要支持分布式事务
                    let bussiness = this.ticketEntity.enterbyusername == 'incident' ? 'INCIDENT3' : 'INCIDENT'
                    var requestUrl = "/ticket/ticketToWorkFlowAccept/" + bussiness + "/" + busineesId;

                    var resDate = await draftReceivingOrders(requestUrl, formData);
                    if (resDate.code == '200') {
                        this.receivingOrdersDisabled = false;
                        //刷新查询页面得右上角得工作流状态
                        this.$refs.ticketDetail.queryTicketDetail(this.ticketEntity.ticketid);
                        //刷新流转信息
                        this.$refs['ticketDetail'].$refs['ticketWorkflowInfoRef'].getHistoryList();

                        //修改按钮
                        this.updateShow = true;
                        //删除按钮
                        this.deleteShow = false;
                    } else {
                        this.receivingOrdersDisabled = false;
                        resDate.message = resDate.message.replace('失败！失败原因：系统错误，请联系管理员', '');
                    }

                    this.$message.success(resDate.message);


                } else {
                    this.$message.success('请先保存事件信息再接单!');
                }
            }
        },
        //重新审核
        async reexamine() {
            //防止重复提交
            this.reexamineDisabled = true;
            var business = {
                'bussiness': this.ticketEntity.enterbyusername == 'incident' ? 'INCIDENT3' : 'INCIDENT',
                'bussinessId': this.ticketEntity.ticketuid,
                'params': JSON.stringify({
                    'room_id': this.ticketEntity.dcnum,
                    'STATUS': this.workStatus
                }),
                "reopen": true,
                "token": localStorage.getItem("token"),
                "appId": "WEB"
            };
            var response;
            try {
                response = await WorkflowApiNew.request(business);
            } catch (error) {
                this.$message.error(error);
                this.sendWorkFlowButtonDisabled = false;
                return;
            }

            /*if(response.code=="ERROR"||response.code=="CLOSED"){
                this.$message.success(response.message);
                this.sendWorkFlowButtonDisabled=false;
                return;
            }*/

            this.reexamineDisabled = false;
            this.initWorkflowModal(response, business.params);

        },
        //制作事件报告
        async makeEventReport() {
            this.eventReportDisabled = true;
            //校验当前ticket是否有数据报告，有则提示已经有数据报告不能再制作！
            var ticketId = $("#ticketId").val();
            var url = "/ticket/checkHasReport?ticketId=" + this.ticketEntity.ticketid + "&appId=WEB&token=" + localStorage.getItem("token");
            var response = await queryEventReportHas(url);
            if (response.data == 'true') {
                this.eventReportDisabled = false;
                this.$message.success('当前事件已经存在事件报告!(提示:一个事件只能制作一个事件报告)');
                return;
            }

            if (this.ticketEntity.ticketid == null || this.ticketEntity.dcnum == null) {
                this.$message.success('ticketId为空,不能制作事件报告!dcnum数据中心不能为空!');
                return;
            }
            //弹窗
            this.eventReportDisabled = false;
            var sysUserList = await CommonServiceApi.getSysuserList(this.ticketEntity.dcnum);

            this.$refs.EventReportPicker.visible = true;
            this.$refs.EventReportPicker.sysUserList = sysUserList.data;
            this.$refs.EventReportPicker.ticketid = this.ticketEntity.ticketid;
            this.$refs.EventReportPicker.username = null;


        },
        //发送工作流弹窗确定回调函数
        async afterAuditWorkflowFunc(param) {

            if (this.isDataEmpty(param.nextNodeId)) {
                this.$message.success('下一节点必填!');
                this.$refs.WorkFlowDialogPicker.disabldButton = false;
                return;
            }

            if (!this.isDataEmpty(this.sendWorkFlowForm.actualfinish)) {
                if (this.isDateNotValid(this.ticketEntity.actualstart, this.sendWorkFlowForm.actualfinish)) {
                    this.$message.success('开始时间要小于等于事件恢复时间!');
                    this.$refs.WorkFlowDialogPicker.disabldButton = false;
                    return;
                }
            }
            if (this.workStatus == 'WHANDLE') {//待处理

                if (this.isDataEmpty(this.sendWorkFlowForm.actualfinish)) {
                    this.$message.success('事件恢复时间必填!');
                    this.$refs.WorkFlowDialogPicker.disabldButton = false;
                    return;
                }
            } else if (this.workStatus == 'WAPPR' || this.workStatus == 'CLOSE') {//待审核
                //事件等级必输
                if (this.isDataEmpty(this.sendWorkFlowForm.level)) {
                    this.$message.success('事件等级必填!');
                    this.$refs.WorkFlowDialogPicker.disabldButton = false;
                    return;
                }
                if (this.ifReview == false && param.nextNodeName == this.Constant.closeWorkflowName && this.sendWorkFlowForm.actualfinish == null) {
                    this.$message.success('事件恢复时间必填!');
                    this.$refs.WorkFlowDialogPicker.disabldButton = false;
                    return;
                }
            }

            if ((this.workStatus == 'WAPPR' || this.workStatus == 'CLOSE') && param.nextNodeName == this.Constant.closeWorkflowName) {
                if (this.isDataEmpty(this.sendWorkFlowForm.workflowCreateValidation)) {
                    this.$message.success('创建有效性必填!');
                    this.$refs.WorkFlowDialogPicker.disabldButton = false;
                    return;
                }
                if (this.isDataEmpty(this.sendWorkFlowForm.workflowHandleValidation)) {
                    this.$message.success('处理有效性必填!');
                    this.$refs.WorkFlowDialogPicker.disabldButton = false;
                    return;
                }
            }
            if(!this.ticketEntity.dcnum) {
                this.$message.warning('数据中心不能为空!');
                return
            }

            var infoTicket = {
                'room_id': this.ticketEntity.dcnum,
                'STATUS': this.workStatus,
                'TITLE': this.ticketEntity.description,
                'TICKETID': this.ticketEntity.ticketid,
            };
            var stringifyParam = JSON.stringify(infoTicket);


            //        var jsonData={
            //            'token':localStorage.getItem("token"),
            //            'appId':"WEB",
            //            'params':stringifyParam,
            //            'nextNodeId':param.nextNodeId,
            //            'wfToken':param.wfToken,
            //            'remark' : param.remark,
            //            'afile':param.afile
            //        }

            var formData = new FormData;
            formData.append("token", localStorage.getItem("token"));
            formData.append("appId", "WEB");
            formData.append("params", stringifyParam);
            formData.append("nextNodeId", param.nextNodeId);
            formData.append("previousNodeId", param.previousNodeId);
            formData.append("wfToken", param.wfToken);
            formData.append("remark", param.remark);
            formData.append("afile", param.afile);
            //后台更新 ticket得参数
            var submitParam = {
                "ticketUid": param.ownerId,
                "ticketid": this.ticketEntity.ticketid,
                "status": this.workStatus,
                "nextStatus": null,//后台赋值
                "level": this.sendWorkFlowForm.level,
                "actualfinish": this.sendWorkFlowForm.actualfinish,
                "createValidation": this.sendWorkFlowForm.workflowCreateValidation,
                "handleValidation": this.sendWorkFlowForm.workflowHandleValidation,
                "token": localStorage.getItem("token"),
                "appId": "WEB",
            }

            if (null != this.sendWorkFlowForm.createUser && this.sendWorkFlowForm.createUser.length > 0) {
                submitParam.createUser = this.sendWorkFlowForm.createUser.join(",");
            }
            if (null != this.sendWorkFlowForm.handleUser && this.sendWorkFlowForm.handleUser.length > 0) {
                submitParam.handleUser = this.sendWorkFlowForm.handleUser.join(",");
            }
            formData.append("dto", JSON.stringify(submitParam));
            //jsonData.dto=JSON.stringify(submitParam);
            //前台调用工作流之后调用后台ticket/submit接口换成两个步骤直接调用ticket在从ticket在去调用工作流的项目，因为需要支持分布式事务
            let bussiness = this.ticketEntity.enterbyusername == 'incident' ? 'INCIDENT3' : 'INCIDENT'
            var requestUrl = "/ticket/ticketToWorkFlowAuditForm/" + bussiness + "/" + param.ownerId;
            var resData = await draftSendWorkFlowForm(requestUrl, formData);

            if (resData.code == '200') {
                this.sendWorkFlowButtonDisabled = false;
                this.$refs.WorkFlowDialogPicker.close();

                //刷新查询页面得右上角得工作流状态
                this.$refs.ticketDetail.queryTicketDetail(this.ticketEntity.ticketid);
                //刷新流转信息
                this.$refs['ticketDetail'].$refs['ticketWorkflowInfoRef'].getHistoryList();
            } else {
                this.sendWorkFlowButtonDisabled = false;
                this.$refs.WorkFlowDialogPicker.disabldButton = false;
                resData.message = resData.message.replace('失败！失败原因：系统错误，请联系管理员', '');
            }
            this.$message.success(resData.message);
        },
        //发送工作流弹窗选择下一节点促发事件
        elSelectChangeEvent(label) {
            if (label == '完工') {
                this.createShow = true;
                this.handleShow = true;
            } else {
                this.createShow = false;
                this.handleShow = false;
            }
        },
        //导出
        async exportExcelInfo() {
            if (this.total > 15000) {
                this.$message.success('导出条数过多不能超过一万五千条！');
                return;
            }


            this.exportDisabled = true;
            let data = $.extend({}, this.searchParams);

            if (data.status != null && data.status.length > 0) {
                data.status = data.status.join(",");
            }
            var resData = await exportExcel(data);
            //        alert('1');
            this.exportDisabled = false;
        },
        //FORM修改信息取消
        formCancelFun() {
            //保存按钮
            this.saveShow = false;
            if (this.workStatus == 'DRAFT') {
                //删除按钮
                this.deleteShow = true;
            } else {
                //删除按钮
                this.deleteShow = false;
            }
            //form表单修改取消按钮
            this.formCancel = false;
            //发送工作流按钮
            this.sendWorkFlowShow = true;
            //修改按钮
            this.updateShow = true;

            this.$refs['ticketDetail'].queryTicketDetail(this.ticketEntity.ticketid);
            this.$refs['ticketDetail'].formDisable = true;
        },
        //修改
        updateFunc() {
            //保存按钮
            this.saveShow = true;
            //删除按钮
            this.deleteShow = false;
            //form表单修改取消按钮
            this.formCancel = true;
            //发送工作流按钮
            this.sendWorkFlowShow = false;
            //修改按钮
            this.updateShow = false;
            this.$refs['ticketDetail'].formDisable = false;
        },

        checkSelectable(row) {
            if (row.status == 'CANCEL') {
                return false;
            } else {
                return true;
            }
        },

        selectedEquipmentHandler(equipmentInfo) {
            this.searchParams.assetnum = equipmentInfo.id;
            this.searchParamsNotSendBackstage.assetnumDescriptionNo = equipmentInfo.name;
        },

        selectedLocationHandler(nodeInfo) {
            this.searchParams.location = nodeInfo.referenceId;
            this.searchParamsNotSendBackstage.locationDescriptionNo = nodeInfo.name;
            this.locationTreeDialogVisible = false;
        },
        isRouteQueryExisted() {
            const query = this.$route.query
            Reflect.deleteProperty(query, 'appId')
            Reflect.deleteProperty(query, 'token')
            Reflect.deleteProperty(query, 'm')
            return Object.keys(query).length > 0
        },
        async getMonitorIds() {
            let monitoringAccessIds = []
            if(this.$route.query.incidentGroup == 'YES') {
                const roomRes = await CommonServiceApi.getRoomsByAuthSites()
                let url = `${TICKET_SERVER}/ticket-ids/monitor-wait-accept`
                const {data} = await athubAxios.post(url, {dcnums: roomRes.data.map(item => item.id)})
                var { data: autoIds } = await WorkflowApiNew.fetchCurrentTaskIds('INCIDENT3');
                monitoringAccessIds = _.uniq([...autoIds, ...data.data])
            }
            var response = await WorkflowApiNew.fetchCurrentTaskIds(this.$route.query.processName);
            this.searchParams.ticketuids = [...response.data, ...monitoringAccessIds];
        }
    },
    //指定异步方法
    async created() {
        this.searchParams.ticketuids = null
        if (this.$route.query.source == 'index') {          //首页跳转过来的
            // NOTE: source == 'index'，需要合并的字段 incidentGroup = ‘YES’，
            this.tableLoading = true
            await this.getMonitorIds()
            this.searchParams.currentEvent = null
            this.searchParams.hasChecked = null
        } else if (this.$route.query.sourcePage == 'bigScreen') {    //盯屏跳转而来
            this.$nextTick(() => {
                this.$refs['athubDropDownSearch'].$forceUpdate();

                let params = {...this.$route.query};
                if (this.$route.query.statusList != null && this.$route.query.statusList != '') {
                    this.searchParams.status = this.$route.query.statusList.split(',');
                }
                // params.currentEvent = null;
                if(params.level)
                    this.searchParams.level = params.level
                if(params.source)
                    this.searchParams.source = params.source
                if(params.type)
                    this.searchParams.type = params.type
                if(params.dcnum)
                    this.searchParams.dcnum = params.dcnum
                this.searchParams.currentEvent = null
            });
        } else if(this.$route.query.sourcePage === 'alarm_analysis_repeat') {
            const {dcId, startDate, endDate, equipmentId} = this.$route.query
            if(startDate !== 'undefined' && startDate !== '' && startDate !== 'null') {
                this.searchParams.startTime = startDate
            }
            if(endDate !== 'undefined' && endDate !== '' && endDate !== 'null') {
                this.searchParams.endTime = endDate
            }
            if(dcId !== 'undefined' && dcId !== '' && dcId !== 'null') {
                this.searchParams.dcnum = dcId
            }
            if(equipmentId !== 'undefined' && equipmentId !== '' && equipmentId !== 'null') {
                this.searchParams.assetnum = equipmentId
                await DcimServer.equipment.get(equipmentId).then(r => {
                    this.searchParamsNotSendBackstage.assetnumDescriptionNo = r.name;
                });
            }
            this.searchParams.currentEvent = null
            await this.queryTable();
            this.tickettypes = await queryTicketType();
        } else if(this.$route.query.sourcePage === 'alarm_analysis_storm') {
          const {dcId, startTime, endTime} = this.$route.query
          
            if(startTime !== 'undefined' && startTime !== '' && startTime !== 'null') {
              this.searchParams.ge_actualStart = startTime
              this.searchParams.startTime = dayjs(startTime).format('YYYY-MM-DD')
            }
            if(endTime !== 'undefined' && endTime !== '' && endTime !== 'null') {
              this.searchParams.le_actualStart = dayjs(endTime).endOf('minute').format('YYYY-MM-DD HH:mm:ss')
              this.searchParams.endTime = dayjs(endTime).format('YYYY-MM-DD')
            }
            if(dcId !== 'undefined' && dcId !== '' && dcId !== 'null') {
              this.searchParams.dcnum = dcId
            }

            this.searchParams.currentEvent = null
            await this.queryTable();
            this.tickettypes = await queryTicketType();
        } else if(this.$route.query.sourcePage === 'alarm_analysis_report') {
            const {dcIds, startDate, endDate, status, sources, hasReport, level, handleexpired, acceptexpired, auditexpired, tickettype, tickettypeisnull, failuretype,failuretypeisnull,failurecode, failurecodeisnull, nin_tickettype,nin_failuretype,nin_failurecode, important} = this.$route.query

            if(tickettypeisnull !== 'undefined' && tickettypeisnull !== '' && tickettypeisnull !== 'null' && tickettypeisnull) {
                this.searchParams.tickettypeisnull = true
            }

            this.tickettypes = await queryTicketType();
            if(tickettype !== 'undefined' && tickettype !== '' && tickettype !== 'null' && tickettype) {
                this.searchParams.tickettype = tickettype
                this.failuretypes = await queryFailuretypes(this.searchParams.tickettype);
            }

            if(nin_tickettype !== 'undefined' && nin_tickettype !== '' && nin_tickettype !== 'null' && nin_tickettype) {
                this.searchParams.nin_tickettype = this.tickettypes.map(item => item.failurecode)
            }

            if(failuretype !== 'undefined' && failuretype !== '' && failuretype !== 'null' && failuretype) {
                this.searchParams.failuretype = failuretype
                this.failurecodes = await queryFailurecodes(this.searchParams.failuretype);
            }

            if(nin_failuretype !== 'undefined' && nin_failuretype !== '' && nin_failuretype !== 'null' && nin_failuretype) {
                this.searchParams.nin_failuretype = this.failuretypes.map(item => item.failurecode)
            }

            if(failuretypeisnull !== 'undefined' && failuretypeisnull !== '' && failuretypeisnull !== 'null' && failuretypeisnull) {
                this.searchParams.failuretypeisnull = true
            }

            if(failurecode !== 'undefined' && failurecode !== '' && failurecode !== 'null' && failurecode) {
                this.searchParams.failurecode = failurecode
            }

            if(failurecodeisnull !== 'undefined' && failurecodeisnull !== '' && failurecodeisnull !== 'null' && failurecodeisnull) {
                this.searchParams.failurecodeisnull = true
            }

            if(nin_failurecode !== 'undefined' && nin_failurecode !== '' && nin_failurecode !== 'null' && nin_failurecode) {
                this.searchParams.nin_failurecode = this.failurecodes.map(item => item.failurecode)
            }

            if(startDate !== 'undefined' && startDate !== '' && startDate !== 'null') {
                this.searchParams.startTime = startDate
            }
            if(endDate !== 'undefined' && endDate !== '' && endDate !== 'null') {
                this.searchParams.endTime = endDate
            }
        
            if(dcIds !== 'undefined' && dcIds !== '' && dcIds !== 'null' && dcIds) {
                // 这里限制数据中心下拉选项
                this.filterDcIds = dcIds.split(',')
                this.searchParams.dcnums = dcIds.split(',')
            }

            if(status !== 'undefined' && status !== '' && status !== 'null' && status) {
                this.searchParams.status = status.split(',')
            }

            if(sources !== 'undefined' && sources !== '' && sources !== 'null' && sources) {
                this.searchParams.sources = sources.split(',')
            }

            if(hasReport !== 'undefined' && hasReport !== '' && hasReport !== 'null' && hasReport) {
                this.searchParams.hasReport = 'YES'
            }

            if(level !== 'undefined' && level !== '' && level !== 'null' && level) {
                this.searchParams.level = level
            }

            if(handleexpired !== 'undefined' && handleexpired !== '' && handleexpired !== 'null' && handleexpired) {
                this.searchParams.handleexpired = true
            }

            if(acceptexpired !== 'undefined' && acceptexpired !== '' && acceptexpired !== 'null' && acceptexpired) {
                this.searchParams.acceptexpired = true
            }

            if(auditexpired !== 'undefined' && auditexpired !== '' && auditexpired !== 'null' && auditexpired) {
                this.searchParams.auditexpired = true
            }

            if(important !== 'undefined' && important !== '' && important !== 'null' && important === 'true') {
                this.searchParams.important = true
            }

            this.searchParams.currentEvent = null
        } else {
        if(this.searchParams.currentEvent) {
          this.searchParams.startTime = formatDate(new Date(new Date().getTime() - 24 * 60 * 60 * 1000), 'yyyy-MM-dd')
          this.searchParams.endTime = formatDate(new Date(), 'yyyy-MM-dd')
        } else {
          this.searchParams.startTime = ''
          this.searchParams.endTime = ''
        }
        await this.queryTable();
        this.tickettypes = await queryTicketType();
        //位置弹出框不让他显示开头的input控件
        // this.$refs.LocationPicker.isTure = false;
        }

        //如果是事件报告过来得跳转详情
        if (this.$route.query.TICKETID != undefined) {
            this.activeTab = 'detail_tab';
            this.changeActiveTabControl();
            this.selectedTicketId = this.$route.query.TICKETID;
        }

    },
    computed: {},

    watch: {
        'searchParams.currentEvent': {
            handler(val) {
                // NOTE: 查询前一天到当天的时间段
                if(this.$route.query.source || this.$route.query.sourcePage || this.$route.query.statusList || this.$route.query.TICKETID || this.$route.query.incidentGroup || this.$route.query.processName) {
                    return
                }
                if(val) {
                    this.searchParams.startTime = formatDate(new Date(new Date().getTime() - 24 * 60 * 60 * 1000), 'yyyy-MM-dd')
                    this.searchParams.endTime = formatDate(new Date(), 'yyyy-MM-dd')
                } else {
                    this.searchParams.startTime = ''
                    this.searchParams.endTime = ''
                }
            }
        },
        searchParams: {
            deep: true,
            handler: debounce(function (newVal, oldVal) {
                if (newVal.acceptexpired == true || newVal.auditexpired == true || newVal.handleexpired == true) {
                    this.searchParams.hasChecked = 'YES';
                }
                if ((newVal.acceptexpired == false || newVal.acceptexpired == null) && (newVal.auditexpired == false || newVal.auditexpired == null) && (newVal.handleexpired == false || newVal.handleexpired == null)) {
                    this.searchParams.hasChecked = 'NO';
                }

                if (oldVal.dcnum == null && newVal.dcnum == null) {
                    //显示批量撤单按钮
                    this.flagShow = true;
                    this.btnOpenBatchCancelVisible = true;
                }

                if (oldVal.assetnum == null && newVal.assetnum == null) {
                    this.searchParamsNotSendBackstage.assetnumDescriptionNo = null;
                }
                if (oldVal.location == null && newVal.location == null) {
                    this.searchParamsNotSendBackstage.locationDescriptionNo = null;
                }

                this.currentPage = 1;
                this.total = 0;
                this.tableData = [];
                this.relationNums = '';
                this.queryTable();
            }, 1200)
        },
        //        searchParamsNotSendBackstage:{
        //            deep: true,
        //                    handler: debounce(function (newVal, oldVal) {
        //                if(null!=newVal.statusArrs&&newVal.statusArrs.length>=0){
        //                    this.searchParams.status=newVal.statusArrs.join(",");
        //                }
        //
        //            }, 500)
        //        },
        activeTab: {
            deep: true,
            handler: debounce(function (newVal, oldVal) {

                if (newVal != null && newVal == 'detail_tab') {
                    if (this.addClicked) {
                        this.$refs['ticketDetail'].formDisable = false;
                    } else {
                        this.$refs['ticketDetail'].formDisable = true;
                    }
                } else {
                    this.$refs['ticketDetail'].formDisable = false;
                }


            }, 500)
        }

    },


}

</script>
<style scped>
.starnotice {
    position: absolute;
    left: 15px;
    top: 5px;
    color: red;
}

.starnotice-le {
    position: absolute;
    left: 45px;
    top: 5px;
    color: red;
}

.starnotice-cl {
    position: absolute;
    left: 30px;
    top: 5px;
    color: red;
}

.starnotice-hl {
    position: absolute;
    left: 30px;
    top: 5px;
    color: red;
}

.position-relative {
    position: relative;
}

.margin-l {
    margin-left: -20px;
}

.event-tip {
    background-color: #fff !important;
    color: #409eff !important;
    border: 1px solid #dcdfe6 !important;
}
.event-tip .popper__arrow{
    /* border-width: 5px !important; */
 }
.event-tip[x-placement^=top] .popper__arrow {
    border-top-color: #dcdfe6 !important;
}
.event-tip.is-light[x-placement^=top] .popper__arrow {
    border-top-color: #a4acbe !important;
}
.event-tip[x-placement^=top] .popper__arrow::after {
    border-top-color: #fff !important;
}

.custom-date-picker {
    .el-input__inner {
        height: 28px !important;
    }
}
</style>
